const Module = () => import("./Module.vue");
const Home = () => import("./views/Home.vue");

const moduleRoute = {
  path: "/workplace",
  component: Module,
  children: [
    {
      path: "/",
      name: "workplace-home",
      component: Home,
    },
  ],
};

export default (router) => {
  router.addRoutes([moduleRoute]);
};
